import firebase from 'firebase/app';
import 'firebase/auth';

export default (code: string): void => {
    firebase.auth().languageCode = code;
};
